import React, { useState, useEffect } from "react";

import "../../Styles/Styles/dashboardstyle.css";

import { Link, useNavigate } from "react-router-dom";

import rightImage from "../../Assets/img/Right.png";
// import Logo from "../../Assets/img/paperboylogo.png";
import Logo from "../../Assets/img/the-paperboy-logo-5.png";
import paypal from "../../Assets/img/icons/paypal.png";
import { BASE_URL, IMAGE_URL, security_key } from "../../global";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import PaypalRedirect from "./../Paypal/PaypalRedirect";

const Subscription = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [subscriptionPacks, setSubscriptionPacks] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [amount, setAmount] = useState(null);
    const [recommended, setRecommended] = useState(null);
    const [businessID, setBusinessID] = useState(null);

    const handlePlanSelect = (plan, amount) => {
        setSelectedPlan(plan);
        setAmount(amount);
    };

    const spanstyle = {
        fontSize: "14px",
    };
    const inputfield = {
        width: "300px",
    };
    const submitbtn = {
        width: "100%",
        height: "52px",
        fontSize: "16px",
    };
    const iconStyle = {
        fontSize: "18px",
    };
    const planBox = {
        padding: "7px 7px",
    };
    const [selectedTab, setSelectedTab] = useState("card");

    const handleTabClick = (tab) => {
        setSelectedTab(tab);
    };

    useEffect(() => {
        getAllSubscription();
        getAdminBusinessID();
    }, []);

    const getAllSubscription = async () => {
        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllSubscription",
            });

            const output = response.data;

            if (output.length > 0) {
                setSubscriptionPacks(output.filter((row) => row.sub_status == 1));
                var minRow = output.reduce(
                    (min, row) => {
                        const value = parseInt(row.sub_amount) / parseInt(row.sub_month);
                        return value < min.value ? { row, value } : min;
                    },
                    { row: null, value: Infinity }
                ).row;

                setRecommended(minRow.pk_sub_key);
            }
        } catch (error) {
            toast.error("Error fetching subscription details." + error, {
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const getAdminBusinessID = async () => {
        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAdminBusinessID",
            });

            const output = response.data;

            if (output) {
                setBusinessID(output);
            }
        } catch (error) {
            console.error("Error fetching subscription details." + error);
        } finally {
            setLoading(false);
        }
    };

    const handleProceed = async () => {
        if (!selectedPlan) {
            toast.warning("Please select a plan.", {
                autoClose: 3000,
            });
            return;
        }

        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "goToPaymentApp",
                sub_key: selectedPlan,
            });

            const output = response.data;

            if (output.length > 0) {
                setSubscriptionPacks(output);
            }
        } catch (error) {
            toast.error("Error fetching subscription details." + error, {
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const user_key = sessionStorage.getItem("pk_user_key");
    const status = sessionStorage.getItem("subscription_status");

    useEffect(() => {
        if (user_key) {
            // checkUserSubscriptionStatus(user_key);
            if (status === "yes") {
                navigate("/dashboard");
            }
        } else {
            navigate("/");
        }
    }, [user_key, status]);

    /*
    const checkUserSubscriptionStatus = async (user_key) => {
        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "checkUserSubscriptionStatus",
                user_key: user_key,
            });

            const output = response.data;

            if (output == 1) {
                navigate("/dashboard");
                sessionStorage.setItem("subscribed", "yes");
            }
        } catch (error) {
            // toast.error("Error fetching ." + error, {
            //     autoClose: 3000,
            // });
        } finally {
            setLoading(false);
        }
    };
    */

    return (
        <>
            <ToastContainer position="top-center" />

            <section className=" site-main">
                <div className="container vh-100 d-flex justify-content-center align-items-center flex-wrap">
                    <div className="site-sub-main bg-white">
                        {/* <div className="subscription-field bg-2 " style={{ height: "520px", width: "50%" }}> */}
                        <div className="subscription-field bg-2 " style={{ height: "fit-content", width: "50%" }}>
                            <div className="text-header text-center mt-0">
                                <img src={Logo} className="img-fluid mb-5 mt-5" alt="" />
                                <h2 className="fw-semibold fs-4 mb-1">Subscription</h2>
                                <p className="text-center" style={{ fontSize: "16px" }}>
                                    Choose your plan
                                </p>
                                <div className="container w-75">
                                    <div className="row d-flex flex-wrap justify-content-evenly">
                                        {subscriptionPacks.map((row) => (
                                            <div
                                                key={row.pk_sub_key}
                                                className={`col-md-6 col-lg-6 mb-4`}
                                                // onClick={() => handlePlanSelect(row.pk_sub_key, row.sub_amount)}
                                            >
                                                <div className={`plan-box rounded-3 p-3 ${selectedPlan === row.pk_sub_key ? "selected" : ""}`}>
                                                    <p className="mb-1">{row.sub_name}</p>
                                                    <p className="mb-0 fs-5 fw-bold">
                                                        <strong>${row.sub_amount}</strong>
                                                    </p>
                                                    <span>{row.sub_month} month</span>
                                                    {/* <div className="sug-box px-1 rounded-1"></div> */}
                                                    {row.pk_sub_key == recommended && <div className="sug-box px-1 rounded-1"></div>}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="field d-flex justify-content-center align-items-center" style={{ height: "520px" }}>
                            <div className="sub-fields">
                                <div className="text-header mt-5 text-center">
                                    <h2 className="fw-semibold fs-4 mt-sm-2">Start your account</h2>
                                    <form className="pt-35" style={{ marginBottom: "40px" }}>
                                        <div className="pay-card-home d-flex justify-content-center align-items-center gap-2">
                                            {/* Card Option */}
                                            <div
                                                className={`pay-card position-relative card p-4 text-center ${
                                                    selectedTab === "card" ? "border-success shadow-sm border-2 bg-light-green" : "border-secondary"
                                                }`}
                                                style={{  width: "150px" }}
                                                // style={{ cursor: "pointer", width: "150px" }}
                                                // onClick={() => handleTabClick("card")}
                                            >
                                                {/* Credit Card Icon */}
                                                <i className="fa-regular fa-credit-card f-20"></i>
                                                <h6 className="mt-2">Card</h6>

                                                {/* Tick Icon (Only shows if selected) */}
                                                {selectedTab === "cards" && (
                                                    <i
                                                        className="fa fa-check-circle text-success position-absolute"
                                                        style={{
                                                            top: "2px",
                                                            right: "1px",
                                                            fontSize: "18px",
                                                        }}
                                                    ></i>
                                                )}
                                            </div>

                                            {/* PayPal Option */}
                                            <div
                                                className={`pay-card position-relative card p-4 text-center ${
                                                    selectedTab === "paypal" ? "border-success shadow-sm border-2 bg-light-green" : "border-secondary"
                                                }`}
                                                style={{ width: "150px" }}
                                                // style={{ cursor: "pointer", width: "150px" }}
                                                // onClick={() => handleTabClick("paypal")}
                                            >
                                                {/* PayPal Icon */}
                                                <i className="fa-brands fa-paypal f-20"></i>
                                                <h6 className="mt-2">PayPal</h6>

                                                {/* Tick Icon (Only shows if selected) */}
                                                {selectedTab === "paypal" && (
                                                    <i
                                                        className="fa fa-check-circle text-success position-absolute"
                                                        style={{
                                                            top: "2px",
                                                            right: "1px",
                                                            fontSize: "18px",
                                                        }}
                                                    ></i>
                                                )}
                                            </div>
                                        </div>

                                        <div className="btn-grp mt-3 w-100" style={{display:"none"}}>
                                            <PaypalRedirect business={businessID} amount={amount} subKey={selectedPlan} />
                                        </div>
                                        <div className="btn-grp mt-3 w-100">
                                            <Link
                                                to="/invite-topline"
                                                type="button"
                                                style={submitbtn}
                                                className="btn btn-dark text-white d-flex align-items-center justify-content-center fw-semibold"
                                            >
                                                Proceed
                                            </Link>
                                            {/* <Link
                                                to="/dashboard"
                                                type="button"
                                                style={submitbtn}
                                                className="btn btn-dark text-white d-flex align-items-center justify-content-center fw-semibold"
                                            >
                                                Skip
                                            </Link> */}
                                            {/* <button
                                                type="button"
                                                style={submitbtn}
                                                className="btn btn-dark text-white d-flex align-items-center justify-content-center fw-semibold"
                                                onClick={() => {
                                                    // Clear session data to log the user out
                                                    sessionStorage.removeItem("pk_user_key");
                                                    sessionStorage.removeItem("subscription_status");
                                                    sessionStorage.removeItem("user_email");
                                                    sessionStorage.setItem("isLoggedIn", "false");

                                                    window.location.href = BASE_URL; 
                                                }}
                                            >
                                                Skip
                                            </button> */}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <style jsx>
                {`
                    .nav-tabs {
                        border: none;
                    }
                    .nav-item {
                        width: 92px;
                    }
                    .nav-link {
                        display: flex;
                        align-items: start;
                        flex-direction: column;
                        padding: 8px 16px;
                    }
                    .nav-tabs .nav-item .nav-link {
                        border: 1px solid #ccc;
                        border-radius: 4px;
                    }
                    .nav-tabs .nav-item:hover,
                    .nav-tabs .nav-link:hover,
                    .nav-tabs .nav-link:focus {
                        border-color: #ccc;
                    }
                    .nav-tabs .nav-link.active {
                        border: 1px solid #454545;
                        background-color: #f8f9fa;
                    }
                    .plan-box {
                        border: 2px solid white;
                        background-color: white;
                        transition: all 0.3s ease;
                    }
                    .plan-box:hover {
                        border: 2px solid black;
                    }
                    .selected {
                        background-color: black;
                        color: white;
                    }
                `}
            </style>
        </>
    );
};

export default Subscription;
